const api = typeof window === 'undefined' ? global.API : window.API

// ------------------------------------
// elastic.search({
//   index: "test",
//   body: {
//     query: {
//       query_string: {
//         query: "id:abc"
//       }
//     },
//     size: 1000
//   },
//   _sourceIncludes: "fields"
// })
// ------------------------------------
exports.find = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/simple/find`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

// ------------------------------------
// elastic.index({
//   index: "test",
//   id: "abc",
//   body: { hello:"world"}
// })
// ------------------------------------
exports.save = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/simple/save`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

// ------------------------------------
// elastic.get( {
//   index: "test",
//   id: "abc",
//   refresh: true
// } )
// ------------------------------------
exports.read = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/simple/read`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

// const response = await client.mget({
//   index: 'myindex',
//   type: 'mytype',
//   body: {
//     ids: [1, 2, 3]
//   }
// });
exports.list = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/simple/list`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}

// const response = await client.mget({
//   index: 'myindex',
//   id: 'id',
// });
exports.remove = async function ( body ) {

  const token = localStorage.getItem( "token" )

  const params = {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      "authorization": `Token ${token}`
    },
    body: JSON.stringify( body )
  }

  return fetch( `${api}/simple/remove`, params ).then( res => res.json() ).catch( err => ( {
    meta: { status: "Service unavailable", code: 503, message: err.message }
  } ) )

}